<template>
  <ElAutocomplete
    v-slot="{ item }"
    :fetch-suggestions="querySearch"
    :trigger-on-focus="false"
    :debounce="250"
    :hide-loading="true"
    class="w-full"
    v-bind="$attrs"
    v-model="fieldValue"
    v-on="inputListeners"
    @select="handleSelect"
  >
    <FontAwesomeIcon
      :icon="['fas', 'map-marker-alt']"
      class="text-primary-light mr-15"
    />
    <span class="main-value text-primary-light">
      <span class="main-text">{{ mainTextLabel(item.structuredFormatting).firstPart }}</span>
      <span class="main-text font-bold">{{ mainTextLabel(item.structuredFormatting).matchingSubString }}</span>
      <span class="main-text">{{ mainTextLabel(item.structuredFormatting).lastPart }}</span>
    </span>
    <span class="text-xs text-gray-400 pl-5">{{ item.structuredFormatting.secondary_text }}</span>
  </ElAutocomplete>
</template>

<script>
import loadExternalScript from '@/utils/loadExternalScript';

const googleMapsPlacesAPIKey = 'AIzaSyCZMXeG3kCHT7cScIyaSWEd3iDJxlzYVJs';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fieldValue: this.value,
      autocompleteService: null,
    };
  },
  mounted() {
    loadExternalScript(`https://maps.googleapis.com/maps/api/js?key=${googleMapsPlacesAPIKey}&libraries=places`)
      .then(() => {
        const { google } = window;

        this.autocompleteService = new google.maps.places.AutocompleteService();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    inputListeners() {
      const vm = this;
      // `Object.assign` merges objects together to form a new object
      // eslint-disable-next-line prefer-object-spread
      return Object.assign(
        {},
        // We add allEvents the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input(newValue) {
            vm.$emit('input', newValue);
          },
          change(event) {
            vm.$emit('change', event);
          },
        },
      );
    },
  },
  methods: {
    querySearch(queryString, callback) {
      if (!this.autocompleteService) return;

      this.autocompleteService.getQueryPredictions({ input: queryString }, (predictions, status) => {
        const { google } = window;
        if (status !== google.maps.places.PlacesServiceStatus.OK) {
          callback([]);
          return;
        }

        const results = [];

        predictions.forEach((prediction) => {
          results.push({
            value: prediction.description,
            label: prediction.place_id,
            structuredFormatting: prediction.structured_formatting,
            placeID: prediction.place_id,
          });
        });

        callback(results);
      });
    },
    mainTextLabel(structuredFormatting) {
      const matchedSubStringOffset = structuredFormatting.main_text_matched_substrings[0].offset;
      const matchedSubStringLength = structuredFormatting.main_text_matched_substrings[0].length;
      const firstPart = structuredFormatting.main_text.substring(0, matchedSubStringOffset);
      const matchingSubString = structuredFormatting.main_text.substring(
        matchedSubStringOffset,
        matchedSubStringLength + matchedSubStringOffset,
      );
      const lastPart = structuredFormatting.main_text.substring(
        matchedSubStringLength + matchedSubStringOffset,
        structuredFormatting.main_text.length,
      );

      return {
        firstPart,
        matchingSubString,
        lastPart,
      };
    },
    handleSelect(item) {
      this.fieldValue = item.value;
      this.$emit('google-place-id-update', item.placeID);
    },
  },
};
</script>

<style scoped>
li {
  line-height: normal;
  padding: 7px;

  .main-value {
    @apply overflow-hidden;
    text-overflow: ellipsis;

    .main-text {
      @apply inline-block;

      white-space: pre-wrap;
    }
  }

  &:hover .icon, &.highlighted .icon {
    @apply text-secondary;
  }
}
</style>
